import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {PredmetPonuka} from '../model/PredmetPonuka';
import {Predmet} from '../model/predmet';
import { HttpClient } from '@angular/common/http';
import {VyberJazykaComponent} from '../vyber-jazyka/vyber-jazyka.component';
import {StudijnyPlanItem} from '../model/StudijnyPlanItem';
import {delay} from 'rxjs/operators';
import {AppService} from '../app.service';
import {TranslateService} from '@ngx-translate/core';
import {MatDialog} from '@angular/material/dialog';

@Component({
    selector: 'app-predmet-z-ponuky',
    templateUrl: './predmet-z-ponuky.component.html',
    styleUrls: ['./predmet-z-ponuky.component.css'],
    standalone: false
})
export class PredmetZPonukyComponent implements OnInit {

  @Input() predmet: PredmetPonuka;
  @Output() saved = new EventEmitter<boolean>();

  light: boolean;
  detail: Predmet;

  panelOpenState = false;

  constructor(
    private http: HttpClient,
    private appService: AppService,
    private translation: TranslateService,
    private dialogService: MatDialog
  ) { }

  ngOnInit(): void {
  }

  onAfterExpand() {
    if (!this.detail) {
      this.http.get<Predmet>('/ais/rest/portal/student-predmety/predmet/' + this.predmet.idPredmetRok + '/v2')
        .subscribe(
          predmet => this.detail = predmet,
          error => console.error(error)
        );
    }
  }

  onClick($event: MouseEvent) {
    $event.stopPropagation();

    this.light = true;

    if (this.predmet.jazyk.length > 1) {

      const dialogRef = this.dialogService.open(
        VyberJazykaComponent, {
          data: {
            predmet: this.predmet
          }
        });

      dialogRef.afterClosed().subscribe(result => {
        this.zapisPredmet(this.predmet, result);
      });

    }
    else {
      this.zapisPredmet(this.predmet, this.predmet.jazyk[0]);
    }
  }

    private zapisPredmet(predmet: PredmetPonuka, jazyk: string)
    {
        predmet.jazyk = [jazyk];

        this.http
            .post<PredmetPonuka>('/ais/rest/portal/student-predmety/zapis-ponuka', predmet)
            .pipe(delay(250))
            .subscribe({
                next: () => this.onZapisSuccess(),
                error: (error) => this.handleZapisError(error, predmet, jazyk)
            });
    }


    private onZapisSuccess(): void
    {
        this.appService.openSnackBar(
            this.translation.instant('Predmet bol zapísaný do zápisného listu.')
        );
        this.appService.fetchPredmety();
        this.saved.emit(true);
        this.light = false;
    }


    private handleZapisError(error: any, predmet: PredmetPonuka, jazyk: string): void
    {
        if (error?.error?.type === 'warning')
        {
            this.appService.openConfirmDialog(error.error.message)
                .afterClosed()
                .subscribe((res) => {
                    if (res === 'OK') {
                        const predmetCopy = Object.assign(new PredmetPonuka(), predmet);
                        predmetCopy.warnings = [...(predmet.warnings || [])];
                        predmetCopy.addWarning(error.error);
                        this.zapisPredmet(predmetCopy, jazyk);
                    } else {
                        this.light = false;
                    }
                });

            return;
        }

        this.light = false;
        this.appService.openErrorDialog(error?.error?.message ?? 'Unknown error');
    }


  getPredmetInfoMobile(predmet: PredmetPonuka): string {
    const out = [];

    if (predmet.semester) {
      out.push(predmet.semester + 'S');
    }

    if (predmet.rozsah) {
      out.push(predmet.rozsah);
    }

    if (predmet.kredit) {
      out.push(predmet.kredit + this.translation.instant('kreditSkratka'));
    }

    return out.join('; ');
  }

}
